<template>
  <div @keyup.enter="confirm">
    <div class="filter-title">{{ title }}</div>

    <UiInputText v-model="text" static-placeholder placeholder="Текст" type="text" />

    <div class="filter-operation">
      <UiButton :class="['button', 'is-small', 'is-blue']" @click="confirm"> Применить </UiButton>
      <UiButton :class="['button', 'is-small', 'is-light']" @click="reset"> Очистить </UiButton>
    </div>
  </div>
</template>

<script>
import common from './common'

export default {
  components: {
    UiInputText: () => import('@/components/UiInputText.vue'),
    UiButton: () => import('@/components/UiButton.vue'),
  },
  mixins: [common],
  data() {
    return {
      text: '',
    }
  },
  watch: {
    '$route.query': {
      handler: 'setQueryText',
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.updateQueryParams({
        query: {
          ...this.$query,
          page: null,
          [this.queryKey]: null,
        },
      })

      this.closeFn()
    },

    confirm() {
      this.updateQueryParams({
        query: {
          ...this.$query,
          page: null,
          [this.queryKey]: this.text,
        },
      })

      this.closeFn()
    },

    setQueryText() {
      this.text = this.$query[this.queryKey]
    },
  },
}
</script>
